var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListNumberEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.75H16.75V13H8V11.75ZM8 3H16.75V4.25H8V3ZM3 5.5V0.5H1.75V1.125H0.5V2.375H1.75V5.5H0.5V6.75H4.25V5.5H3ZM4.25 15.5H0.5V13C0.5 12.6685 0.631696 12.3505 0.866116 12.1161C1.10054 11.8817 1.41848 11.75 1.75 11.75H3V10.5H0.5V9.25H3C3.33152 9.25 3.64946 9.3817 3.88388 9.61612C4.1183 9.85054 4.25 10.1685 4.25 10.5V11.75C4.25 12.0815 4.1183 12.3995 3.88388 12.6339C3.64946 12.8683 3.33152 13 3 13H1.75V14.25H4.25V15.5Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNumberEditorIcon);
export default __webpack_public_path__ + "static/media/list-number-editor-icon.bc1ef59e32d0c10906296e1a292fd7b8.svg";
export { ForwardRef as ReactComponent };